/*
 * Author Nirjhor
 * Title: Center Stock Reconcile
 * Description: Center Stock Reconcile
 * Date: 13/08/2026
 */

import { Button, Card } from 'react-bootstrap';
import { useStockReconcile } from './ContextAPI';
import DataTable from './DataTable';
import FormInfo from './FormInfo';
import ShowModel from './ShowModel';

export default function Index() {
    const { show, setShow, rowData, setRowData } = useStockReconcile();
    const createHander = () => {
        setShow(true);
        setRowData('');
    };
    const backHander = () => {
        setShow(false);
        setRowData('');
    };
    return (
        <>
            <Card>
                <Card.Header className="cardHeader">
                    <h3>Center Stock Reconcile</h3>
                    {show ? (
                        <div>
                            <Button
                                onClick={() => backHander()}
                                className="btnInfo"
                                variant="primary"
                            >
                                Back to List
                            </Button>
                        </div>
                    ) : (
                        <div>
                            <Button
                                onClick={() => createHander()}
                                className="btnInfo"
                                variant="primary"
                            >
                                Create New
                            </Button>
                        </div>
                    )}
                </Card.Header>
                <Card.Body>{show ? <FormInfo editData={rowData} /> : <DataTable />}</Card.Body>
            </Card>
            <ShowModel />
        </>
    );
}
